<div class="dashboard">
  <div class="main-section" *ngIf="!isMunicipalityDeactivated" cdkDropListGroup>
    <div [class.one-ep-colors]="oneEPColors">
      <div class="favorites-section" (mouseover)="displayFavoriteInstruction = true" (mouseout)="displayFavoriteInstruction = false">
        <h4 class="title">
          {{ 'module.dashboard.favoriteTitleText' | translate }}
        </h4>
        <span class="instruction-text-hover" [ngClass]="displayFavoriteInstruction ? 'instruction-display' : ''" *ngIf="favoriteAppList.length !== 0">
          {{ 'module.dashboard.favoritesInstructionText' | translate }}
        </span>

        <div class="favorite-items favorite-drag-drop-section">
          <ng-container *ngFor="let item of favoriteAppList; let i = index">
            <div
              class="cdkDropList-favorites"
              cdkDropList
              cdkDropListOrientation="horizontal"
              id="favoriteList"
              [cdkDropListData]="{
                container: favoriteAppList,
                item: item,
                index: i
              }"
              (cdkDropListDropped)="drop($event)"
            >
              <div class="drag-box" cdkDrag [cdkDragData]="{ data: item, index: i }" [cdkDragPreviewClass]="oneEPColors ? ['one-ep-colors'] : []">
                <div class="example-custom-placeholder" *cdkDragPlaceholder></div>
                <app-dashboard-panel
                  *ngIf="item.code !== 'ENERGY_GUARD' && (!item.isRestricted || item.isTeaser)"
                  class="{{ item.class }}"
                  title="{{ item.title | translate }}"
                  hoverSrc="{{ item.hoverSrc }}"
                  src="{{ item.src }}"
                  routerLink="{{ item.routerLinkValue }}"
                  (click)="handleClickEvent(item.code, item.clickTrackName, item.isTeaser, item)"
                  [isPremium]="item.isPremium"
                  [isTeaser]="item.isTeaser"
                  [isWarmeDaten]="item.isWarmeDaten"
                  [isNewTeaserText]="item.isNewTeaserText"
                  [item]="item"
                  [hasNotification]="item.code ==='MYDOCS_PAGE' && myDocsHasNotification"
                >
                </app-dashboard-panel>

                <app-dashboard-panel
                  *ngIf="item.code === 'ENERGY_GUARD' && (!item.isRestricted || item.isTeaser)"
                  class="{{ item.class }}"
                  title="{{ item.title | translate }}"
                  hoverSrc="./assets/icons/EnergieWachter_EW-{{ municipalityAlarm && municipalityAlarm.hasActiveAlarm ? 'red' : 'green' }}-3d.svg"
                  src="{{ item.src }}"
                  routerLink="{{ item.routerLinkValue }}"
                  badgeCount="{{ municipalityAlarm ? municipalityAlarm.alarmsCount : 0 }}"
                  (click)="handleClickEvent(item.code, item.clickTrackName, item.isTeaser, item)"
                  [isPremium]="item.isPremium"
                  [isTeaser]="item.isTeaser"
                  [isNewTeaserText]="item.isNewTeaserText"
                  [item]="item"
                >
                </app-dashboard-panel>

                <img *ngIf="item.isRestricted && !item.isTeaser" class="restricted-favorite" src="./assets/icons/default-blank-fav.svg" alt="defaultFavorite" />
              </div>
            </div>
          </ng-container>

          <div
            class="empty-favorite-section"
            id="favoriteList"
            cdkDropList
            cdkDropListOrientation="horizontal"
            (cdkDropListDropped)="drop($event)"
            *ngIf="favoriteAppList.length > 0 && favoriteAppList.length < 5"
          ></div>

          <div class="no-favorite" cdkDropList cdkDropListOrientation="horizontal" (cdkDropListDropped)="drop($event)" *ngIf="favoriteAppList.length === 0">
            <span class="default-blank-favorites"></span>
            <span class="text">
              <p class="instruction-text">
                {{ 'module.dashboard.favoritesInstructionText' | translate }}
              </p>
            </span>
          </div>
        </div>
      </div>

      <mat-divider></mat-divider>

      <div class="application-section" (mouseover)="displayInstruction = true" (mouseout)="displayInstruction = false">
        <h4 class="title top-line">
          {{ 'module.dashboard.applicationTitleText' | translate }}
        </h4>
        <span class="instruction-text-hover" [ngClass]="displayInstruction ? 'instruction-display' : ''">
          {{ 'module.dashboard.nonFavoritesInstructionText' | translate }}
        </span>
        <div class="application-items non-favorite-list">
          <ng-container *ngFor="let item of nonFavoriteAppList; let i = index" class="application-items non-favorite-list">
            <div
              cdkDropList
              cdkDropListOrientation="horizontal"
              *ngIf="!item.isRestricted || (item.isRestricted && item.isTeaser)"
              class="cdkDropList-nonFavorite"
              id="nonFavoriteList"
              [cdkDropListData]="{
                container: nonFavoriteAppList,
                item: item,
                index: i
              }"
              (cdkDropListDropped)="drop($event)"
            >
              <div class="drag-box" cdkDrag [cdkDragData]="{ data: item, index: i }" [cdkDragPreviewClass]="oneEPColors ? ['one-ep-colors'] : []">
                <div class="example-custom-placeholder" *cdkDragPlaceholder></div>
                <app-dashboard-panel
                  *ngIf="item.code !== 'ENERGY_GUARD' && item.code !== 'MYDOCS_PAGE'"
                  class="{{ item.class }}"
                  title="{{ item.title | translate }}"
                  hoverSrc="{{ item.hoverSrc }}"
                  src="{{ item.src }}"
                  routerLink="{{ item.routerLinkValue }}"
                  (click)="handleClickEvent(item.code, item.clickTrackName, item.isTeaser, item)"
                  [isPremium]="item.isPremium"
                  [isTeaser]="item.isTeaser"
                  [isWarmeDaten]="item.isWarmeDaten"
                  [isNewTeaserText]="item.isNewTeaserText"
                  [item]="item"
                >
                </app-dashboard-panel>

                <app-dashboard-panel
                  *ngIf="item.code === 'MYDOCS_PAGE'"
                  class="{{ item.class }}"
                  title="{{ item.title | translate }}"
                  hoverSrc="{{ item.hoverSrc }}"
                  src="{{ item.src }}"
                  routerLink="{{ item.routerLinkValue }}"
                  (click)="handleClickEvent(item.code, item.clickTrackName, item.isTeaser, item)"
                  [isPremium]="item.isPremium"
                  [isTeaser]="item.isTeaser"
                  [isWarmeDaten]="item.isWarmeDaten"
                  [isNewTeaserText]="item.isNewTeaserText"
                  [item]="item"
                  [hasNotification]="myDocsHasNotification"
                >
                </app-dashboard-panel>

                <app-dashboard-panel
                  *ngIf="item.code === 'ENERGY_GUARD'"
                  class="{{ item.class }}"
                  title="{{ item.title | translate }}"
                  hoverSrc="./assets/icons/EnergieWachter_EW-{{ municipalityAlarm && municipalityAlarm.hasActiveAlarm ? 'red' : 'green' }}-3d.svg"
                  src="{{ item.src }}"
                  routerLink="{{ item.routerLinkValue }}"
                  badgeCount="{{ municipalityAlarm ? municipalityAlarm.alarmsCount : 0 }}"
                  (click)="handleClickEvent(item.code, item.clickTrackName, item.isTeaser, item)"
                  [isPremium]="item.isPremium"
                  [isTeaser]="item.isTeaser"
                  [isNewTeaserText]="item.isNewTeaserText"
                  [item]="item"
                >
                </app-dashboard-panel>
              </div>
            </div>
          </ng-container>

          <div
            class="empty-favorite-section"
            id="nonFavoriteList"
            cdkDropList
            cdkDropListOrientation="horizontal"
            (cdkDropListDropped)="drop($event)"
            *ngIf="nonFavoriteAppList.length > 0 && nonFavoriteAppList.length < 5"
          ></div>
          <div
            class="no-unfavorite"
            cdkDropList
            cdkDropListOrientation="horizontal"
            (cdkDropListDropped)="drop($event)"
            *ngIf="nonFavoriteAppList.length === 0"
          >
            <span class="default-blank-favorites"></span>
            <span class="text">
              <img class="dash-icon" alt="close-icon" src="../../../../assets/icons/no-dashboard.png" />
              <p class="instruction-text">
                {{ 'module.dashboard.allAppsInFavoritesText' | translate }}
              </p>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="right-side-section" *ngIf="!!authService.permissions.INFORMATION && information.length > 0">
    <div class="panel events-section">
      <div class="header">
        <h6 class="title">{{ 'module.information.moduleName' | translate }}</h6>
      </div>
      <div class="content">
        <app-information-preview [data]="information"></app-information-preview>
      </div>
    </div>
  </div>

  <div class="error-overlay" *ngIf="showErrorMessage">
    <div class="error-container">
      <div class="close-button">
        <img class="x-icon" alt="close-icon" src="./assets/icons/close-icon-gray.svg" (click)="showErrorMessage = false" />
      </div>
      <div class="description">
        <span class="icon">
          <div class="circle">
            <i class="fa fa-star" aria-hidden="true"></i>
          </div>
        </span>
        <span class="error-text">
          <p class="message title">
            {{ 'module.dashboard.errorTitleText' | translate }}
          </p>
          <p class="message" [innerHTML]="'module.dashboard.errorMessageText' | translate"></p>
        </span>
      </div>
    </div>
  </div>
</div>
